import Vue from 'vue'
const moment = require('moment-timezone')

function formatCurrency (value) {
  const v = Math.round(Number(value) * 100) / 100
  let curString = v.toLocaleString()
  if (curString.indexOf('.') === -1) {
    curString += '.00'
  } else if (curString.split('.')[1].length === 1) {
    curString += '0'
  }
  return curString
}

Vue.filter('title', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  const arr = value.split(replacer)
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

/**
 * Date vue filter
 * Converts PostgreSQL date string to datepicker date string
 */
Vue.filter('filterDate', function (value, userTimezone) {
  const valueCheck = new Date(value)
  if (!valueCheck) {
    return 'None provided'
  }

  if (valueCheck.getFullYear() < 1990) {
    return 'None provided'
  }

  // Timezone conversion
  const utz = userTimezone
  let tiz = ''
  if (utz === 'EST') {
    tiz = 'America/New_York'
  } else if (utz === 'CST') {
    tiz = 'America/Chicago'
  } else if (utz === 'MST') {
    tiz = 'America/Denver'
  } else if (utz === 'PST') {
    tiz = 'America/Los_Angeles'
  } else if (utz === 'HST') {
    tiz = 'Pacific/Honolulu'
  }
  const utcDate = moment.tz(value, 'Europe/London')
  return (utcDate.tz(tiz)).format('MM/DD/YYYY')
})

/**
 * Binding type filter
 * Converts Binding type to string
 * @param value - Value to format
 */
Vue.filter('bookTypeFilter', function (value) {
  let v = ''
  value = Number(value)

  if (value === 1) {
    v = 'Saddle Stitched'
  } else if (value === 2) {
    v = 'Saddle Stitched - B&W'
  } else if (value === 3) {
    v = 'Soft Cover Perfect Bound'
  } else if (value === 4) {
    v = 'Perfect Bound - B&W'
  } else if (value === 5) {
    v = 'Standard Hard Cover'
  } else if (value === 6) {
    v = 'Hard Cover - B&W'
  } else if (value === 7) {
    v = 'Coil Bound'
  } else if (value === 8) {
    v = 'Coil Bound - B&W'
  } else if (value === 9) {
    v = 'Smyth Hard Cover'
  } else if (value === 10) {
    v = 'Side Sewn Hard Cover'
  }

  return v
})

/**
 * Binding type filter for sales reps
 * Converts Binding type to string
 * @param value - Value to format
 */
Vue.filter('salesRepBookTypeFilter', function (value) {
  let v = ''
  value = Number(value)

  if (value === 1) {
    v = 'Saddle Stitched'
  } else if (value === 2) {
    v = 'Saddle Stitched - B&W'
  } else if (value === 3) {
    v = 'Soft Cover Perfect Bound'
  } else if (value === 5) {
    v = 'Standard Hard Cover'
  } else if (value === 9) {
    v = 'Smyth Hard Cover'
  } else if (value === 10) {
    v = 'Side Sewn Hard Cover'
  }

  return v
})

/**
 * Cover type filter
 * Converts cover type to string
 * @param value - Value to format
 */
Vue.filter('coverTypeFilter', function (value) {
  let v = ''
  value = Number(value)

  if (value === 1) {
    v = 'Simplex'
  } else if (value === 2) {
    v = 'Duplex'
  }

  return v
})

/**
 * Personalization type filter
 * Converts personalization type to string
 * @param value - Value to format
 */
Vue.filter('personalizationTypeFilter', function (value) {
  let v = ''
  value = Number(value)

  if (value === 0) {
    v = 'No personalization'
  } else if (value === 1) {
    v = 'Name on cover'
  } else if (value === 2) {
    v = 'Name and photo on cover'
  } else if (value === 3) {
    v = 'None'
  } else if (value === 4) {
    v = 'Name and icons on cover'
  }

  return v
})

/**
 * Software type vue filter
 * Converts software type to string
 * @param value - Value to format
 */
Vue.filter('softwareTypeFilter', function (value) {
  value = Number(value)
  let v = ''

  if (value === 0) {
    v = 'None / PDF Submission'
  } else if (value === 1) {
    v = 'LumaPix Desktop'
  } else if (value === 2) {
    v = 'LumaPix Online'
  } else if (value === 3) {
    v = 'Pixami'
  } else if (value === 4) {
    v = 'Captura Yearbooks'
  } else if (value === 5) {
    v = 'Fluid Media'
  } else if (value === 6) {
    v = 'Creator Studio'
  } else if (value === 7) {
    v = 'Memento'
  } else if (value === 8) {
    v = 'Pictavo'
  } else if (value === 9) {
    v = 'Store Only'
  } else if (value === 10) {
    v = 'ConnectMe'
  }

  return v
})

Vue.filter('printerFilter', function (value) {
  value = Number(value)
  let v = 'None Listed'

  if (value === 1) {
    v = 'Studio Source'
  } else if (value === 2) {
    v = 'Walter\'s'
  }

  return v
})

Vue.filter('coverStyleFilter', function (value) {
  value = Number(value)
  let v = ''

  if (value === 0) {
    v = 'None'
  } else if (value === 1) {
    v = 'Standard Printed (Litho)'
  } else if (value === 2) {
    v = 'Specialty'
  }

  return v
})

Vue.filter('coverApplicationFilter', function (value) {
  value = Number(value)
  let v = ''

  if (value === 0) {
    v = 'None'
  } else if (value === 1) {
    v = 'Scodix Polymer'
  } else if (value === 2) {
    v = 'Foil'
  } else if (value === 3) {
    v = 'Scodix Foil'
  } else if (value === 4) {
    v = 'Foil'
  } else if (value === 5) {
    v = 'Silkscreen'
  } else if (value === 6) {
    v = 'Embossing'
  } else if (value === 7) {
    v = 'Debossing'
  } else if (value === 8) {
    v = 'Laser Cut'
  } else if (value === 9) {
    v = 'TouchTeq'
  } else if (value === 9) {
    v = 'Other'
  } else if (value === 11) {
    v = 'Foil - Gold'
  } else if (value === 12) {
    v = 'Foil - Silver'
  } else if (value === 13) {
    v = 'Foil - Other'
  }

  return v
})

Vue.filter('endsheetTypeFilter', function (value) {
  value = Number(value)
  let v = ''

  if (value === 1) {
    v = 'Front and Back'
  } else if (value === 2) {
    v = 'Front Only'
  } else if (value === 3) {
    v = 'Back Only'
  }

  return v
})

/**
 * Proof status vue filter
 * Converts software type to string
 * @param value - Value to format
 */
Vue.filter('proofStatusFilter', function (value) {
  value = Number(value)
  let v = ''

  if (value === 1) {
    v = 'Needs Review'
  } else if (value === 2) {
    v = 'Rejected'
  } else if (value === 3) {
    v = 'Approved'
  }

  return v
})

/**
 * Proof internal status vue filter
 * Converts internal proof status to string
 * @param value - Value to format
 */
Vue.filter('proofInternalStatusFilter', function (value) {
  value = Number(value)
  let v = ''

  if (value === 1) {
    v = 'Awaiting Review'
  } else if (value === 2) {
    v = 'Rejected'
  } else if (value === 3) {
    v = 'Approved'
  } else if (value === 4) {
    v = 'Ignore'
  } else if (value === 5) {
    v = 'In Progress'
  } else if (value === 6) {
    v = 'Studio Contacted' // Was waiting on studio
  } else if (value === 7) {
    v = 'Customer Resubmitting'
  } else if (value === 8) {
    v = 'Customer Approves as Is'
  }

  return v
})

// Define a shared status mapping function
function getStatusDescription (status) {
  const descriptions = {
    '-2': 'Error',
    '-1': 'Processing',
    '0': 'Waiting',
    '1': 'Submitted',
    '2': 'Shipped',
    '3': 'Delivered',
    '4': 'Customizing',
    '5': 'Customized',
    '6': 'Only School Copies Delivered',
    '7': 'Only Studio Copies Delivered',
    '8': 'Both Copies Delivered',
    '9': 'Canceled in Mfg',
    '10': 'Mfg Hold',
    '11': 'In Production',
    '12': 'Lost in Transit' }
  return descriptions[status] || '' // Return the description or an empty string if not found
}

// Shipment status Vue filter using shared function
Vue.filter('shipmentStatusFilter', function (value) {
  return getStatusDescription(Number(value))
})

/**
 * Order status vue filter
 * @param order - Order object
 */
Vue.filter('orderStatusFilter', function (order) {
  let v = getStatusDescription(order.status)

  if (order.status === 2) {
    if (order.shippingMethod === 'PP') {
      v = 'Ready for Pickup'
    } else if (order.bCombineCopies || order.countExtras === 0) {
      v = 'Shipped'
    } else if (!order.bCombineCopies && order.countExtras > 0) {
      if (order.schoolTracking === null) {
        v = 'Only Studio Copies Shipped'
      } else if (order.studioTracking === null) {
        v = 'Only School Copies Shipped'
      } else {
        v = 'Both Copies Shipped'
      }
    }
  // Else if submitted and account's parent must prepay, or account is a commission school
  } else if (order.status === 1 &&
             order.typeOrder === 1 &&
             order.account &&
             order.account.parent &&
             order.account.parent.bMustPayBeforeProduction) {
    v = 'Waiting for Payment'
  }
  return v
})

/**
 * Order type vue filter
 * @param order - Order object
 */
Vue.filter('orderTypeFilter', function (orderType) {
  let v = 'Unknown'

  if (orderType === 0) {
    return 'Proof'
  } else if (orderType === 1) {
    return 'Production'
  } else if (orderType === 2) {
    return 'Sample'
  } else if (orderType === 3) {
    return 'Redo'
  } else if (orderType === 5) {
    return 'Summer Single STH'
  }
  return v
})

/**
 * Queue proof status vue filter
 * Converts queue proof status to string
 * @param value - Value to format
 */
Vue.filter('proofProcessingStatusFilter', function (value) {
  let v = ''
  value = Number(value)

  if (value === 0) {
    v = 'Waiting'
  } else if (value === 1) {
    v = 'Processing'
  } else if (value === 2) {
    v = 'Complete'
  } else if (value === 3) {
    v = 'Error'
  } else if (value === 4) {
    v = 'Attention'
  } else if (value === 5) {
    v = 'Addressed'
  }

  return v
})

/**
 * Queue upload status vue filter
 * Converts queue upload status to string
 * @param value - Value to format
 */
Vue.filter('uploadStatusFilter', function (value) {
  let v = ''
  value = Number(value)

  if (value === 0) {
    v = 'Waiting'
  } else if (value === 1) {
    v = 'Processing'
  } else if (value === 2) {
    v = 'Complete'
  } else if (value === 3) {
    v = 'Error'
  } else if (value === 4) {
    v = 'Attention'
  } else if (value === 5) {
    v = 'Addressed'
  }

  return v
})

/**
 * Queue order move status vue filter
 * Converts queue order move status to string
 * @param value - Value to format
 */
Vue.filter('orderMoveStatusFilter', function (value) {
  let v = ''
  value = Number(value)

  if (value === 0) {
    v = 'Waiting'
  } else if (value === 1) {
    v = 'Processing'
  } else if (value === 2) {
    v = 'Complete'
  } else if (value === 3) {
    v = 'Error'
  } else if (value === 4) {
    v = 'Attention'
  } else if (value === 5) {
    v = 'Addressed'
  }

  return v
})

/**
 * Queue notification status vue filter
 * Converts queue notification status to string
 * @param value - Value to format
 */
Vue.filter('notificationStatusFilter', function (value) {
  let v = ''
  value = Number(value)

  if (value === 0) {
    v = 'Waiting'
  } else if (value === 1) {
    v = 'Processing'
  } else if (value === 2) {
    v = 'Complete'
  } else if (value === 3) {
    v = 'Error'
  } else if (value === 4) {
    v = 'Attention'
  } else if (value === 5) {
    v = 'Addressed'
  }

  return v
})

/**
 * Queue notification status vue filter
 * Converts queue notification status to string
 * @param value - Value to format
 */
Vue.filter('epubStatusFilter', function (value) {
  let v = ''
  value = Number(value)

  if (value === 0) {
    v = 'Waiting'
  } else if (value === 1) {
    v = 'Processing'
  } else if (value === 2) {
    v = 'Complete'
  } else if (value === 3) {
    v = 'Error'
  } else if (value === 4) {
    v = 'Attention'
  } else if (value === 5) {
    v = 'Addressed'
  }

  return v
})

/**
 * Queue notification status style vue filter
 * Converts queue notification status to string
 *
 * @param value - Value to format
 */
Vue.filter('notificationTypeFilter', function (value) {
  let v = ''
  value = Number(value)

  if (value === 1) {
    v = 'Proof Ready'
  } else if (value === 2) {
    v = 'Proof Rejected'
  } else if (value === 3) {
    v = 'No New Proof'
  } else if (value === 4) {
    v = 'Proof Approved'
  } else if (value === 5) {
    v = 'Order Submitted'
  } else if (value === 6) {
    v = 'Order Shipped'
  } else if (value === 7) {
    v = 'Order Delivered'
  } else if (value === 8) {
    v = 'No Files Uploaded'
  } else if (value === 9) {
    v = 'Only One File Uploaded'
  } else if (value === 10) {
    v = 'Invalid Cover Dimensions'
  } else if (value === 11) {
    v = 'Invalid Page Dimensions'
  } else if (value === 12) {
    v = 'Invalid Page Count for Saddle-Stitched'
  } else if (value === 13) {
    v = 'Book Type Mismatch'
  } else if (value === 14) {
    v = 'No Preorder Information'
  } else if (value === 15) {
    v = 'Supplier Notification Error'
  } else if (value === 16) {
    v = 'Project with No Account'
  } else if (value === 18) {
    v = 'PDF Count > 2'
  } else if (value === 19) {
    v = 'No Book Type'
  } else if (value === 20) {
    v = 'Order with No Quantity'
  } else if (value === 21) {
    v = 'Invalid Page Count'
  } else if (value === 24) {
    v = 'Unable to Process Project'
  } else if (value === 27) {
    v = 'Order Builder Failed'
  } else if (value === 34) {
    v = 'Approval with no Order'
  } else if (value === 35) {
    v = 'S3 Upload Error'
  } else if (value === 36) {
    v = 'Invalid Saddle-Stitched Page Count'
  } else if (value === 37) {
    v = 'Order Received by Linemark'
  } else if (value === 38) {
    v = 'Online Order with no Order'
  } else if (value === 39) {
    v = 'Online Order with no Proof'
  } else if (value === 40) {
    v = 'Online Order Shipped'
  } else if (value === 77) {
    v = 'School Copies Delivered'
  } else if (value === 78) {
    v = 'Studio Copies Delivered'
  } else if (value === 79) {
    v = 'Proof not Approved'
  } else if (value === 80) {
    v = 'Order Received by Supplier'
  } else if (value === 81) {
    v = 'No Account with Captura Yearbooks ID'
  } else if (value === 82) {
    v = 'Order moved to VIP'
  } else if (value === 83) {
    v = 'VIP Contract Submitted'
  } else if (value === 84) {
    v = 'Software Expirations'
  } else if (value === 85) {
    v = 'Studio Software Expirations'
  } else if (value === 86) {
    v = 'Order Retrieval Failed'
  } else if (value === 87) {
    v = 'Order Cancelled'
  } else if (value === 88) {
    v = 'No Studio Copies after 48hrs'
  } else if (value === 90) {
    v = 'Approved Proof Rejected'
  } else if (value === 91) {
    v = 'Email Permanent Failure'
  } else if (value === 92) {
    v = 'Project Processor Error'
  } else if (value === 93) {
    v = 'Sending Internal Comments'
  } else if (value === 94) {
    v = 'Due Date Countdown'
  } else if (value === 95) {
    v = 'Store Coupon Used'
  } else if (value === 96) {
    v = 'Order in Producion > 5 Days'
  } else if (value === 97) {
    v = 'Account Software Type Changed'
  } else if (value === 98) {
    v = 'Processor Error'
  } else if (value === 99) {
    v = 'Processor not Running'
  } else if (value === 100) {
    v = 'Project Warnings'
  } else if (value === 101) {
    v = 'Personalization Ordered'
  } else if (value === 102) {
    v = 'Pixami Split Binding'
  } else if (value === 103) {
    v = 'Order in Shipped > 5 Days'
  } else if (value === 104) {
    v = 'Orders to Ship'
  } else if (value === 105) {
    v = 'EPUB Ready'
  } else if (value === 106) {
    v = 'Cover is Blank'
  }  else if (value === 107) {
    v = 'LTL Ready to Ship'
  }  else if (value === 108) {
    v = 'LTL Shipped'
  } else if (value === 109) {
    v = 'LTL Delivered'
  } else if (value === 110) {
    v = 'Proof Passed Technical Review'
  } else {
    v = 'Unknown'
  }

  return v
})

/**
 * Stripe card vue filter
 * Converts stripe card type abbr to full text
 * @param value - Value to format
 */
Vue.filter('stripeCardTypeFilter', function (value) {
  let v = ''

  if (value === 'visa') {
    v = 'Visa'
  } else if (value === 'amex') {
    v = 'American Express'
  } else if (value === 'mastercard') {
    v = 'Master Card'
  } else if (value === 'discover') {
    v = 'Discover'
  }

  return v
})

/**
 * Invoice product type filter
 * Converts invoice product type to string
 * @param value - Value to format
 */
Vue.filter('invoiceProductTypeFilter', function (value) {
  let v = ''
  value = Number(value)

  if (value === 1) {
    v = 'School Yearbooks'
  } else if (value === 2) {
    v = 'Church Directories'
  } else if (value === 3) {
    v = 'Yearbook Creation Kits'
  } else if (value === 4) {
    v = 'Envelopes'
  } else if (value === 5) {
    v = 'Sales Poster'
  } else if (value === 6) {
    v = 'Software Licenses'
  }

  return v
})

/**
 * Invoice product type filter
 * Converts invoice product type to string
 * @param value - Value to format
 */
Vue.filter('upperCase', function (value) {
  return value.toUpperCase()
})

/**
 * Book size filter
 * Converts book size to string
 *
 * @param value - Value to format
 */
Vue.filter('sizeTypeFilter', function (value) {
  let v = ''
  value = Number(value)

  if (value === 5) {
    v = '5.5" x 8.5"'
  } else if (value === 8) {
    v = '8.5" x 11"'
  } else if (value === 9) {
    v = '9" x 12"'
  } else if (value === 11) {
    v = '11.5" x 8.5"'
  }

  return v
})

/**
 * Finish type filter
 * Converts cover finish type to string
 *
 * @param value - Value to format
 */
Vue.filter('finishTypeFilter', function (value) {
  let v = ''
  value = Number(value)

  if (value === 1) {
    v = 'UV - Gloss'
  } else if (value === 2) {
    v = 'UV - Matte'
  } else if (value === 3) {
    v = 'Laminate - Gloss'
  } else if (value === 4) {
    v = 'Laminate - Matte'
  } else if (value === 6) {
    v = 'Gloss Linen'
  } else if (value === 7) {
    v = 'Matte Linen'
  } else if (value === 8) {
    v = 'Unsure'
  } else if (value === 99) {
    v = 'Gloss Laminate 80# pgs'
  } else if (value === 98) {
    v = 'Gloss Laminate 100# pgs'
  } else if (value === 97) {
    v = 'Matte Laminate 80# pgs'
  } else if (value === 96) {
    v = 'Matte Laminate 100# pgs'
  } else if (value === 95) {
    v = 'Luxe Linen 80# pgs'
  } else if (value === 94) {
    v = 'Luxe Linen 100# pgs'
  }

  return v
})

/**
 * Finish type filter
 * Converts cover finish type to string
 *
 * @param value - Value to format
 */
Vue.filter('productTypeFilter', function (value) {
  let v = ''
  value = Number(value)

  if (value === 1) {
    v = 'Yearbooks'
  } else if (value === 2) {
    v = 'Dedication Ads'
  } else if (value === 3) {
    v = 'Text Only Dedications'
  } else if (value === 4) {
    v = 'Forever Connected Yearbooks'
  }
  return v
})

/**
 * Envelope type filter
 * Converts envelope type to string
 * @param value - Value to format
 */
Vue.filter('envelopeTypeFilter', function (value) {
  let v = 'None'
  value = Number(value)

  if (value === 1) {
    v = 'Blank'
  } else if (value === 2) {
    v = 'Printed'
  }

  return v
})

/**
 * Dedication ad type vue filter
 * Converts dedication ad type to string
 * @param value - Value to format
 */
Vue.filter('dedicationAdTypeFilter', function (value) {
  let v = 'N/A'

  if (value === 1) {
    v = 'Full Page'
  } else if (value === 2) {
    v = 'Half Page'
  } else if (value === 3) {
    v = '1/4 Page'
  } else if (value === 4) {
    v = '1/8 Page'
  }

  return v
})

/**
 * Dedication ad type vue filter
 * Converts dedication ad type to string
 * @param value - Value to format
 */
Vue.filter('productShippingTypeFilter', function (value) {
  let v = 'N/A'

  if (value === 0) {
    v = 'Digital Only'
  } else if (value === 1) {
    v = 'Bulk ship to home / school'
  } else if (value === 2) {
    v = 'Summer single book'
  }

  return v
})

/**
 * Account type vue filter
 * Converts account type to string
 * @param value - Value to format
 */
Vue.filter('accountTypeFilter', function (value) {
  let v = 'None'

  if (value === 1) {
    v = 'Preschool'
  } else if (value === 2) {
    v = 'Elementary'
  } else if (value === 3) {
    v = 'Middle'
  } else if (value === 4) {
    v = 'K-8'
  } else if (value === 5) {
    v = 'K-12'
  } else if (value === 6) {
    v = 'High School'
  } else if (value === 7) {
    v = 'Church'
  } else if (value === 8) {
    v = 'Team'
  } else if (value === 9) {
    v = 'Studio'
  } else if (value === 10) {
    v = 'Sales Rep / Branch Office'
  } else if (value === 11) {
    v = 'University'
  } else if (value === 12) {
    v = 'Dance'
  }

  return v
})

/**
 * Account type vue filter
 * Converts account type to string
 * @param value - Value to format
 */
Vue.filter('whereCreatedTypeFilter', function (value) {
  let v = 'N/A'

  if (value === 1) {
    v = 'School'
  } else if (value === 2) {
    v = 'Studio'
  }

  return v
})

/**
 * Account type vue filter
 * Converts account type to string
 * @param value - Value to format
 */
Vue.filter('roleTypeFilter', function (value) {
  let v = 'None'

  if (value === 8) {
    v = 'Studio Owner'
  } else if (value === 7) {
    v = 'Studio Administrator'
  } else if (value === 16) {
    v = 'Studio Contact'
  } else if (value === 3) {
    v = 'School Administrator'
  } else if (value === 5) {
    v = 'School Yearbook Adviser'
  } else if (value === 6) {
    v = 'School Yearbook Volunteer'
  } else if (value === 99) {
    v = 'Sales Rep'
  } else if (value === 20) {
    v = 'Treasurer'
  } else if (value === 22) {
    v = 'School Yearbook Sales Manager'
  }

  return v
})

/**
 * Online order payment type filter
 * Converts online order payment type to string
 * @param value - Value to format
 */
Vue.filter('onlineOrderPaymentTypeFilter', function (value) {
  let v = 'N/A'

  if (value === 2) {
    v = 'Credit card'
  } else if (value === 3) {
    v = 'Check'
  } else if (value === 4) {
    v = 'Cash'
  }

  return v
})

/**
 * Online order shipping type filter
 * Converts online order shipping type to string
 * @param value - Value to format
 */
Vue.filter('onlineOrderShippingTypeFilter', function (value) {
  let v = 'Digital only'

  if (value === 0) {
    v = 'Digital only'
  } else if (value === 1) {
    v = 'Ships to school'
  } else if (value === 2) {
    v = 'Summer single order'
  } else if (value === 3) {
    v = 'Bulk ship to home'
  }

  return v
})

/**
 * Where software credentials type filter
 * Converts where software credentials type to string
 * @param value - Value to format
 */
Vue.filter('whereSoftwareCredentialsTypeFilter', function (value) {
  let v = 'N/A'

  if (value === 1) {
    v = 'School & Studio'
  } else if (value === 2) {
    v = 'Studio only'
  }

  return v
})

/**
 * Filters discount type
 * Converts discount type value to string
 * @param value - Value to format
 */
Vue.filter('discountTypeFilter', function (value) {
  let v = ''
  value = Number(value)

  if (value === 1) {
    v = 'Percentage'
  } else if (value === 2) {
    v = 'Dollar'
  }

  return v
})

/**
 * Fund request status filter
 * Converts fund request status value to string
 * @param value - Value to format
 */
Vue.filter('fundRequestStatusFilter', function (value) {
  let v = ''
  value = Number(value)

  if (value === 0) {
    v = 'Waiting'
  } else if (value === 2) {
    v = 'Complete'
  }

  return v
})

/**
 * Sales tax request status filter
 * Converts sales tax request status value to string
 * @param value - Value to format
 */
Vue.filter('salesTaxRequestStatusFilter', function (value) {
  let v = ''
  value = Number(value)

  if (value === 0) {
    v = 'Waiting'
  } else if (value === 2) {
    v = 'Complete'
  }

  return v
})

/**
 * Cover board weight filter
 * Converts cover board weight numeric value to string
 * @param value - Value to format
 */
Vue.filter('coverBoardWtFilter', function (value) {
  let v = ''
  value = Number(value)

  if (value === 0) {
    v = 'N/A'
  } else if (value === 100) {
    v = '100pt'
  } else if (value === 120) {
    v = '120pt'
  }

  return v
})

/**
 * Shipping method filter
 * Converts shipping code to full shipping method name
 * @param value - Value to format
 */
Vue.filter('shippingMethodFilter', function (value) {
  let v = 'N/A'

  if (value === 'U2A') {
    v = '2nd-Day Air'
  } else if (value === '2D') {
    v = '2nd-Day'
  } else if (value === '3D') {
    v = '3-Day'
  } else if (value === 'F1') {
    v = 'FedEx Overnight'
  } else if (value === 'F2') {
    v = 'FedEx 2-Day'
  } else if (value === 'F3') {
    v = 'FedEx 3-day'
  } else if (value === 'FC') {
    v = 'First Class'
  } else if (value === 'FG') {
    v = 'FedEx Ground'
  } else if (value === 'FH') {
    v = 'FedEx Home'
  } else if (value === 'FP') {
    v = 'FedEx Priority Overnight'
  } else if (value === 'FW') {
    v = 'FedEx Weekend Delivery'
  } else if (value === 'I1') {
    v = 'International Express'
  } else if (value === 'I2') {
    v = 'International 2nd-Day'
  } else if (value === 'IE') {
    v = 'International Express'
  } else if (value === 'IG') {
    v = 'International Ground'
  } else if (value === 'IS') {
    v = 'International'
  } else if (value === 'UP') {
    v = 'Overnight'
  } else if (value === 'ON') {
    v = 'Overnight'
  } else if (value === 'PR') {
    v = 'Priority Mail'
  } else if (value === 'UG') {
    v = 'UPS Ground'
  } else if (value === 'GC') {
    v = 'UPS Ground'
  } else if (value === 'U1') {
    v = 'UPS Overnight'
  } else if (value === 'U2') {
    v = 'UPS 2-Day'
  } else if (value === 'U3') {
    v = 'UPS 3-Day'
  } else if (value === 'UB') {
    v = 'UPS Basic'
  } else if (value === 'UW') {
    v = 'UPS Weekend Delivery'
  } else if (value === 'DL') {
    v = 'Consolidated'
  } else if (value === 'SG') {
    v = 'Standard Ground'
  } else if (value === 'DIS') {
    v = 'DHL International'
  } else if (value === 'BP') {
    v = 'UPS MI'
  } else if (value === 'PA') {
    v = 'Pre Addressed Ship-to-Home'
  } else if (value === 'NS') {
    v = 'TBD'
  } else if (value === 'LTL') {
    v = 'LTL (Less Than Truckload) Common Carrier'
  } else if (value === 'PP') {
    v = 'Plant Pickup'
  }

  return v
})

/**
 * Printed endsheet type filter
 * Converts type printed endsheets from integer to string
 * @param value - Value to format
 */
Vue.filter('printedEndsheetTypeFilter', function (value) {
  let v = ''
  value = Number(value)

  if (value === 0) {
    v = 'None'
  } else if (value === 1) {
    v = 'Front and Back'
  } else if (value === 2) {
    v = 'Front Only'
  } else if (value === 3) {
    v = 'Back Only'
  }

  return v
})


/**
 * Manufacturer filter
 * Converts manufacturer abbreviation to
 * @param value - Value to format
 */
Vue.filter('manufacturerFilter', function (value) {
  let v = ''

  if (!value) {
    v = 'None'
  } else if (value === 'APAL') {
    v = 'Alexander\'s - Lindon'
  } else if (value === 'DL') {
    v = 'Digital Lizard'
  } else if (value === 'DLH') {
    v = 'Digital Lizard - Hayden'
  } else if (value === 'DLLV') {
    v = 'Digital Lizard - Las Vegas'
  } else if (value === 'DPI') {
    v = 'DPI'
  } else if (value === 'DPIB') {
    v = 'DPI - Beltsville'
  } else if (value === 'DPIP') {
    v = 'DPI - Phoenix'
  } else if (value === 'HRI') {
    v = 'HR Imaging'
  } else if (value === 'MIMM') {
    v = 'Mimeo - Memphis'
  } else if (value === 'SHOOB') {
    v = 'Shoob Photo'
  } else if (value === 'SCHPICS') {
    v = 'SCHPICS'
  } else if (value === 'SUP') {
    v = 'Superior'
  } else if (value === 'VIP') {
    v = 'VIP'
  } else if (value === 'WALT') {
    v = 'Walters'
  } else if (value === 'ACUL') {
    v = 'Acutrack'
  } else if (value === 'ADVW') {
    v = 'Advertek Inc. - Woodbridge'
  } else if (value === 'ADVN') {
    v = 'Advertek Inc. - Niagara Falls'
  } else if (value === 'APSC') {
    v = 'APS'
  } else if (value === 'BGT') {
    v = 'Bennett Graphics'
  } else if (value === 'BRPI') {
    v = 'BR Printers - Independence'
  } else if (value === 'BRPS') {
    v = 'BR Printers - San Jose'
  } else if (value === 'CFTL') {
    v = 'Corefact - Louisville'
  } else if (value === 'CFTS') {
    v = 'Corefact - San Leandro'
  } else if (value === 'HPS') {
    v = 'Hudson Printing'
  } else if (value === 'IMPE') {
    v = 'Impactica'
  } else if (value === 'ODGP') {
    v = 'Office Depot - Dallas'
  } else if (value === 'ODS') {
    v = 'Office Depot - Seattle'
  } else if (value === 'ONPP') {
    v = 'On Press'
  }
  return v
})

/**
 * Formats currency displayed to two decimals and comma for thousands
 * Converts float to USD currency (two decimal places) and comma for thousands
 * @param value - Value to format
 */
Vue.filter('formatCurrencyDisplayFilter', function (value) {
  return `$${formatCurrency(value)}`
})

/**
 * Formats currency displayed to two decimals and comma for thousands
 * Converts float to USD currency (two decimal places) and comma for thousands, but with no $ sign
 * @param value - Value to format
 */
Vue.filter('formatCurrencyDisplayNoDollarSignFilter', function (value) {
  return formatCurrency(value)
})

/**
 * Binding designation filter for pricing records
 * Converts binding designation to are more informational string
 * @param value - Value to format
 */
Vue.filter('bindingDesignationFilter', function (value) {
  let v = ''

  if (value === 'A') {
    v = 'A'
  } else if (value === 'B') {
    v = 'B'
  } else if (value === 'C') {
    v = 'C'
  } else if (value === 'D') {
    v = 'D'
  } else if (value === 'E') {
    v = 'E'
  } else if (value === 'F') {
    v = 'F'
  } else if (value === 'G') {
    v = 'G'
  } else if (value === 'H') {
    v = 'H (DTS)'
  } else if (value === 'I') {
    v = 'I (GCI)'
  } else if (value === 'J') {
    v = 'J (Fox-Mar; Deprecated)'
  } else if (value === 'K') {
    v = 'K (Comm-10%)'
  } else if (value === 'L') {
    v = 'L (Comm-15%)'
  } else if (value === 'M') {
    v = 'M (Comm-20%)'
  } else if (value === 'N') {
    v = 'N (Comm-25%)'
  } else if (value === 'O') {
    v = 'O (Comm-0%)'
  } else if (value === 'P') {
    v = 'P (Comm-5%)'
  }
  return v
})

/**
 * Pricing adjustment filter
 * Converts pricing adjustment type to string representation
 * @param value - Value to format
 */
Vue.filter('pricingAdjustmentFilter', function (value) {
  let v = ''

  if (value === 0) {
    v = 'None'
  } else if (value === 1) {
    v = 'Per Book'
  } else if (value === 2) {
    v = 'Total Dollar'
  } else if (value === 3) {
    v = 'Percentage of Invoice'
  } else if (value === 4) {
    v = 'Free Books'
  }
  return v
})

/**
 * Marketing campaign status filter
 * Converts marketing campaign status to string
 * @param value - Value to format
 */
Vue.filter('marketingCampaignStatusFilter', function (value) {
  let v = ''

  if (value === -1) {
    v = 'None'
  } else if (value === 0) {
    v = 'Stopped'
  } else if (value === 1) {
    v = 'Running'
  } else if (value === 2) {
    v = 'Ended'
  }
  return v
})

/**
 * Formats a marketing campaign touchpoint date ('YYYY-MM-DD') to a more human readable date
 * @param value - Value to format ('YYYY-MM-DD')
 */
Vue.filter('marketingTouchpointDateFormat', function (val) {
  return moment.utc(val, 'YYYY-MM-DD').format('MM/DD/YYYY')
})
